import { RouterProvider } from "react-router/dom";
import { router } from "./routes";

export function AppRouter() {
  return <RouterProvider router={router} />;
}
